var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderFIlter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 1.33333V3.33333",
    stroke: "#787486",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.33333V3.33333",
    stroke: "#787486",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.33333C12.8867 2.45333 14 3.29999 14 6.43333V10.5533C14 13.3 13.3333 14.6733 10 14.6733H6C2.66667 14.6733 2 13.3 2 10.5533V6.43333C2 3.29999 3.11333 2.45999 5.33333 2.33333H10.6667Z",
    stroke: "#787486",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 11.7333H2.16667",
    stroke: "#787486",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 5.5C7.17999 5.5 6.48666 5.94667 6.48666 6.81333C6.48666 7.22667 6.67999 7.54 6.97333 7.74C6.56666 7.98 6.33333 8.36667 6.33333 8.82C6.33333 9.64667 6.96666 10.16 7.99999 10.16C9.02666 10.16 9.66666 9.64667 9.66666 8.82C9.66666 8.36667 9.43333 7.97333 9.01999 7.74C9.31999 7.53333 9.50666 7.22667 9.50666 6.81333C9.50666 5.94667 8.82 5.5 7.99999 5.5ZM7.99999 7.39333C7.65333 7.39333 7.4 7.18667 7.4 6.86C7.4 6.52667 7.65333 6.33333 7.99999 6.33333C8.34666 6.33333 8.59999 6.52667 8.59999 6.86C8.59999 7.18667 8.34666 7.39333 7.99999 7.39333ZM7.99999 9.33333C7.55999 9.33333 7.23999 9.11333 7.23999 8.71333C7.23999 8.31333 7.55999 8.1 7.99999 8.1C8.43999 8.1 8.76 8.32 8.76 8.71333C8.76 9.11333 8.43999 9.33333 7.99999 9.33333Z",
    fill: "#787486"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderFIlter);
export default __webpack_public_path__ + "static/media/calenderFIlter.ceb1af21b28cf6ab89f0b24db550177c.svg";
export { ForwardRef as ReactComponent };